import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GooglePlacesService } from 'src/app/services/google-places.service';
import { PlacesService } from 'src/app/services/places.service';

@Component({
  selector: 'app-update-venue',
  templateUrl: './update-venue.component.html',
  styleUrls: ['./update-venue.component.scss']
})
export class UpdateVenueComponent {

  changeForm: FormGroup;
  valueChange: any;
  valueInit: any;
  nameValue: any;
  lugar: string = '';
  searchResults: any[] = [];

  editorConfigVenue: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '400px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Condiciones generales de uso y políticas de compra del espacio.',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Satoshi-Regular',
    defaultFontSize: '',
    uploadUrl: 'v1/image',
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'insertUnorderedList',
        'insertOrderedList',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  constructor(private formBuilder: FormBuilder, private placeService: PlacesService, private googlePlacesService: GooglePlacesService,
    private dialogRef: MatDialogRef<UpdateVenueComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    this.nameValue = this.data['name'];
    this.valueChange = this.data['valueChange'];
    this.valueInit = this.data['value'];
    this.changeForm = this.formBuilder.group({
      name: [this.valueInit.name, Validators.required],
      description: [this.valueInit.description, Validators.required],
      address: [this.valueInit.address],
      latitude: [this.valueInit.latitude],
      longitude: [this.valueInit.longitude],
      membership_title: [this.valueInit.membership_title],
      subscription_text: [this.valueInit.subscription_text],
      slug: [this.valueInit.slug, Validators.required],
      capacity: [this.valueInit.capacity],
      general_conditions: [this.valueInit.general_conditions || ''],
    });

    this.googlePlacesService.openMap();

    this.onSelectPlace(this.changeForm.value.address);

  }

  get value() { return this.changeForm.get(this.valueChange); }

  changeBusiness() {
    if (!this.changeForm.valid) {
      this.changeForm.markAllAsTouched();
      return;
    }
    this.submitVenueChange();
  }

  private submitVenueChange() {
    const value = this.changeForm.value;
    this.valueInit.name = value.name;
    this.valueInit.description = value.description;
    this.valueInit.address = value.address;
    this.valueInit.latitude = value.latitude;
    this.valueInit.longitude = value.longitude;
    this.valueInit.membership_title = value.membership_title;
    this.valueInit.subscription_text = value.subscription_text;
    this.valueInit.slug = value.slug?.replace(/\s+/g, '');
    this.valueInit.capacity = value.capacity;
    this.valueInit.general_conditions = value.general_conditions;

    // Si el campo que se está editando no es el slug, lo excluimos del payload
    // para evitar que el backend lo trate como un slug nuevo y devuelva error de duplicado
    const payload = { ...value };
    if (this.valueChange !== 'slug') {
      delete payload.slug;
    } else {
      payload.slug = payload.slug?.replace(/\s+/g, '');
    }

    if (this.valueChange === 'general_conditions') {
      return this.placeService.updateVenue(this.valueInit.id, { general_conditions: value.general_conditions }).subscribe({
        next: (data) => {
          this.dialogRef.close({ status: 'changed', venue: this.valueInit });
        },
        error: (err) => {
          this.dialogRef.close({ status: 'error', msg: err?.error?.message || 'Error al guardar las condiciones generales' });
        },
      });
    }

    this.placeService.updateVenue(this.valueInit.id, payload).subscribe({
      next: (data) => {
        this.dialogRef.close({ status: 'changed', venue: this.valueInit });
      },
      error: (err) => {
        const backendMsg =
          err?.error?.errors?.slug?.[0] ||
          err?.error?.message ||
          'La URL personalizada ya está en uso';

        this.dialogRef.close({ status: 'error', msg: backendMsg });
      },
    });
  }

  onSearchPlaces() {
    if (this.lugar.length > 3) {
      //const search = this.changeForm.value.address as string;
      this.googlePlacesService.searchPlaces(this.lugar).then((results) => {
        this.searchResults = results;
      });
    } else {
      this.searchResults = [];
    }
  }

  onSelectPlace(text: string) {
    this.googlePlacesService.searchPlaces(text).then((results) => {
      this.lugar = results[0];
      this.googlePlacesService.getDetail(results[0]);
      this.googlePlacesService.mapsLocatorStorage.subscribe({
        next: (data) => {
          if (data) {
            this.changeForm.patchValue({
              address: data.formatted_address,
              latitude: data.geometry.location.lat(),
              longitude: data.geometry.location.lng()
            });
          }
        }
      });
    });
  }

  displayFn(location: any): string {
    if (location) {
      return location.description ? location.description : location.formatted_address;
    }
    return '';
  }
}
